import HttpClient from 'services/api';
import { ENDPOINTS } from 'services/api/endpoints';

export const getCustomers = () => HttpClient.get(ENDPOINTS.CUSTOMERS);

// Retorna detalhes de um cliente pelo ID (GET)
export const getCustomerById = (id) => HttpClient.get(ENDPOINTS.CUSTOMERS.concat(`${id}`));

// Criar novo cliente (POST)
export const createCustomer = (payload) => HttpClient.post(ENDPOINTS.CUSTOMERS, payload);

// Deletar cliente pelo ID (DELETE)
export const deleteCustomer = (id) => HttpClient.delete(ENDPOINTS.CUSTOMERS.concat(`${id}`));

// Atualizar cliente pelo ID (PUT)
export const updateCustomer = (id, payload) => HttpClient.put(ENDPOINTS.CUSTOMERS.concat(`${id}`), payload);

// Retorna hash do cliente (GET)
export const getCustomerHash = (payload) => HttpClient.post(ENDPOINTS.CUSTOMER_HASH, payload);

// Verifica validade de um cupom
export const checkCoupon = (coupon) => HttpClient.get(ENDPOINTS.CHECK_COUPON.replace(':coupon', coupon));
